export enum ModalCloseType {
  CANCEL = 'CANCEL',
  CLOSE = 'CLOSE',
}
